import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AccountPopupField, AccountPopupSaveFooter } from "../BusinessDashboard/accountPopupFields";

const CustomerDetailsPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const steps = [
    {
      title: "First name",
      field: "firstName",
      placeholder: "Enter your first name",
      inputType: "text",
    },
    {
      title: "Last name",
      field: "lastName",
      placeholder: "Enter your last name",
      inputType: "text",
    },
    {
      title: "Mobile number",
      field: "mobileNumber",
      placeholder: "0400 123 456",
      inputType: "tel",
    },
  ];

  const currentStepData = steps[currentStep];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) => (
                  <AccountPopupField
                    step={currentStepData}
                    fieldKey={currentStepData.field}
                    value={values?.[currentStepData.field] ?? ""}
                    onChange={(v) => setFieldValue(currentStepData.field, v)}
                    form={form}
                  />
                )}
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default CustomerDetailsPopup;
